import React, { useState, useEffect, useMemo } from "react";
import http from "../../services/httpService";
import { Ptag } from "../../components/fonts";
import { Table, TopHeader } from "./styles";
import { colors } from "../../theme";

import { Add, AddAPhotoRounded, Remove } from "@material-ui/icons";
import {
  formatAmount,
  formatDateReverse,
  newFormatRupees,
} from "../../utils/utils";
import { Chip, OverlayLoader } from "../../components";
import { capitalize } from "lodash";
import { Tooltip } from "@material-ui/core";
import EmptyFileLottie from "../business/FlexDashboard/EmptyFileLottie";

const tableTitles = [
  "Product",
  "Type",
  "Endorsement Number",
  "Issuance Date",
  "Total Amount",
  "Total Employees",
  "Total Lives",
  "View Documents",
];

const EndorsementHistoryPage = () => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState();

  const getSummeryData = async () => {
    try {
      setLoading(true);
      const { data } = await http.get(`/business/get_payment_summary/`);
      console.log(data, "i am here");
      setTableData(data);
    } catch (ex) {
      console.log({ ex });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async function () {
      await getSummeryData();
    })();
  }, []);

  const tableHeaders = useMemo(() => {
    return tableTitles.map((title, index) => (
      <th
        style={{
          padding: index === 0 ? "1rem 0.8rem" : "1rem 0rem",
          width: "200px",
        }}
      >
        <TopHeader
          style={{
            flexDirection: "column",
          }}
        >
          <Ptag
            fontSize="14px"
            textAlign="center"
            color={colors.primaryColor}
            fontWeight="600"
          >
            {title}
          </Ptag>
          {["Total Employees", "Total Lives"].includes(title) && (
            <Ptag
              fontSize="10px"
              marginTop="4px"
              textAlign="center"
              color={colors.primaryColor}
              fontWeight="600"
            >
              (Addition/Deletion)
            </Ptag>
          )}
        </TopHeader>
      </th>
    ));
  }, []);

  const renderChip = (number, addition) => {
    if (number <= 0) return;
    let bgColor = addition ? "#ECFDF3" : "#FEF3F2";
    let color = addition ? "#027A48" : "#B42318";
    let symbol = addition ? <Add /> : <Remove />;

    return (
      <Chip
        style={{
          marginLeft: !addition ? "1rem" : "0rem",
          borderRadius: "11px",
          fontSize: "11px !important",
        }}
        text={
          <span
            style={{
              color,
              display: "flex",
              alignItems: "center",
            }}
          >
            {symbol} {number}
          </span>
        }
        background={bgColor}
      />
    );
  };

  const renderDocumentChip = (link, text) => {
    if (!link) return;

    return (
      <span
        style={{
          fontSize: "13px",
          color: "#2354D4",
          letterSpacing: 0,
          cursor: "pointer",
          fontFamily: "Inter",
          whiteSpace: "nowrap",
          textTransform: "capitalize",
          textDecoration: "underline",
        }}
        onClick={() => window.open(link)}
      >
        {text}
      </span>
    );

    return (
      <Chip
        background="#2354D4"
        style={{
          color: "white",
          padding: "1rem",
          fontSize: "1.2rem",
          textTransform: "capitalize",
          cursor: "pointer",
          textDecoration: "underline",
        }}
        text={text}
        onClick={() => window.open(link)}
      />
    );
  };
  const getTotalAmount = (value) => {
    var total_amount =
      (value.cgst || 0) +
      (value.igst || 0) +
      (value.sgst || 0) +
      (value.net_premium || 0);
    return newFormatRupees(total_amount);
  };

  return loading ? (
    <OverlayLoader />
  ) : (
    <section
      style={{
        padding: "4rem",
        backgroundColor: "white",
      }}
    >
      <div
        style={
          {
            // maxWidth: "1000px",
          }
        }
      >
        <Ptag
          fontSize="24px"
          fontWeight="700"
          style={{ paddingBottom: "36px" }}
        >
          Enrolment History
        </Ptag>
        {tableData && tableData.length > 0 ? (
          <Table
            id="table-to-xls"
            className="table-striped"
            width="100%"
            cellSpacing="0"
            cellPadding="6"
            showBottomBorder={tableData && tableData.length != 1}
          >
            <tbody>
              <tr style={{ backgroundColor: colors.cardBackgroundColor }}>
                {tableHeaders}
              </tr>
              {tableData &&
                tableData.map((payment_data, index) => {
                  return (
                    <tr key={index} style={{ background: "transparent" }}>
                      <td>
                        <TopHeader>
                          <Ptag fontSize="14px">{payment_data.product}</Ptag>
                        </TopHeader>
                      </td>
                      <td>
                        <TopHeader>
                          <Ptag fontSize="14px">
                            {payment_data.type
                              ? capitalize(payment_data.type)
                              : "-"}
                          </Ptag>
                        </TopHeader>
                      </td>
                      <td>
                        <TopHeader>
                          {payment_data.endorsement_number ? (
                            <Tooltip
                              arrow
                              title={
                                <Ptag color="white">
                                  {payment_data.endorsement_number}
                                </Ptag>
                              }
                              style={{
                                fontSize: "14px !important",
                              }}
                            >
                              <Ptag fontSize="14px" className="truncate-hover" textAlign="center">
                                {payment_data.endorsement_number || "-"}
                              </Ptag>
                            </Tooltip>
                          ) : (
                            "-"
                          )}
                        </TopHeader>
                      </td>
                      <td>
                        <TopHeader>
                          <Ptag fontSize="14px">
                            {(payment_data.transaction_date &&
                              formatDateReverse(
                                payment_data.transaction_date
                              )) ||
                              "-"}
                          </Ptag>
                        </TopHeader>
                      </td>
                      <td>
                        <TopHeader
                          style={{
                            justifyContent: "flex-end",
                          }}
                        >
                          <Ptag fontSize="14px">
                            {getTotalAmount(payment_data)}
                          </Ptag>
                        </TopHeader>
                      </td>
                      <td>
                        <TopHeader>
                          {renderChip(
                            payment_data.no_of_employees_added || 0,
                            true
                          )}
                          {renderChip(
                            payment_data.no_of_employees_deleted || 0
                          )}
                        </TopHeader>
                      </td>
                      <td>
                        <TopHeader>
                          {renderChip(
                            payment_data.no_of_lives_added || 0,
                            true
                          )}
                          {renderChip(payment_data.no_of_lives_deleted || 0)}
                        </TopHeader>
                      </td>
                      <td>
                        <TopHeader
                          style={{
                            gap: "0.8rem",
                            justifyContent: "flex-start",
                          }}
                        >
                          {renderDocumentChip(
                            payment_data.documents.endorsement_file_link,
                            "Employee Sheet"
                          )}
                          {renderDocumentChip(
                            payment_data.documents.invoice_link,
                            `${payment_data.type === "INCEPTION"
                              ? "Inception Copy"
                              : "Endorsement Copy"
                            }`
                          )}
                          {renderDocumentChip(
                        payment_data.documents.employee_break_wise_link,
                        "Premium Breakup"
                      )}
                        </TopHeader>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        ) : (
          <EmptyFileLottie text={"No Data Availble"} />
        )}
      </div>
    </section>
  );
};

export default EndorsementHistoryPage;
